// "admin" = Holding Admin (super-user) — must see all routes ceo can.
// "ceo" reserved for Chủ doanh nghiệp; both roles get full menu.
const ROLE_GROUPS = {
  businessAdmin: ["ceo", "admin", "manager"],
  hrAdmin: ["ceo", "admin", "manager", "hr"],
  leaveApprover: ["ceo", "admin", "manager", "hr"],
  financeAdmin: ["ceo", "admin", "manager", "finance"],
  payroll: ["ceo", "admin", "hr", "finance"],
  kpiAdmin: ["ceo", "admin", "manager", "hr"],
  pos: ["ceo", "admin", "manager", "finance", "restaurant"],
  kds: ["ceo", "admin", "manager", "kitchen"],
  stock: ["ceo", "admin", "manager", "warehouse"],
  excelAdmin: ["ceo", "admin", "manager", "hr", "finance"],
  aiInvoice: ["ceo", "admin", "manager", "finance"],
  shiftAdmin: ["ceo", "admin", "manager", "hr"],
  legalRequester: ["ceo", "admin", "manager", "hr", "finance", "restaurant", "warehouse", "kitchen", "legal_custodian", "legal_approver"],
  legalApprover: ["ceo", "admin", "legal_approver"],
  legalCustodian: ["ceo", "admin", "legal_custodian"],
  legalAuditRead: ["ceo", "admin", "legal_custodian", "legal_approver"],
  // === ROLE GROUPS F01 === Worker inserts legalRequester / legalApprover / legalCustodian ABOVE this marker
  // === END ROLE GROUPS F01 ===
  hrmPositionAdmin: ["ceo", "admin", "hr"],
  hrmTrainingAdmin: ["ceo", "admin", "hr"],
  hrmShiftManager: ["ceo", "admin", "manager", "hr"],
  // === ROLE GROUPS F02 === Worker inserts hrmPositionAdmin / hrmTrainingAdmin / hrmShiftManager ABOVE this marker
  // === END ROLE GROUPS F02 ===
};

const ADMIN_SHELL_ROLES = ["ceo", "admin", "manager", "hr", "finance"];

export const ADMIN_ROUTE_PERMISSIONS = {
  dashboard: ADMIN_SHELL_ROLES,
  companies: ROLE_GROUPS.businessAdmin,
  employees: ROLE_GROUPS.hrAdmin,
  contracts: ROLE_GROUPS.hrAdmin,
  onboarding: ROLE_GROUPS.hrAdmin,
  "org-chart": ROLE_GROUPS.businessAdmin,
  master: ROLE_GROUPS.businessAdmin,
  tasks: ADMIN_SHELL_ROLES,
  attendance: ROLE_GROUPS.leaveApprover,
  shifts: ROLE_GROUPS.shiftAdmin,
  kpi: ROLE_GROUPS.kpiAdmin,
  payroll: ROLE_GROUPS.payroll,
  excel: ROLE_GROUPS.excelAdmin,
  ocr: ROLE_GROUPS.aiInvoice,
  pos: ROLE_GROUPS.pos,
  stock: ROLE_GROUPS.stock,
  kitchen: ROLE_GROUPS.businessAdmin,
  htx: ROLE_GROUPS.businessAdmin,
  "legacy-payroll": ROLE_GROUPS.financeAdmin,
  "audit-history": ADMIN_SHELL_ROLES,
  "legal-vault": ROLE_GROUPS.legalCustodian,
  "legal-requests": ROLE_GROUPS.legalApprover,
  "legal-grants": ROLE_GROUPS.legalCustodian,
  "legal-audit": ROLE_GROUPS.legalAuditRead,
  "staff-legal-request": ROLE_GROUPS.legalRequester,
  // === ROUTE PERMS F01 === Worker inserts legal-vault/legal-requests/legal-audit keys ABOVE this marker
  // === END ROUTE PERMS F01 ===
  "hrm-positions": ROLE_GROUPS.hrmPositionAdmin,
  "hrm-training": ROLE_GROUPS.hrmTrainingAdmin,
  "hrm-daily-work": ROLE_GROUPS.hrmShiftManager,
  "hrm-incidents": ROLE_GROUPS.hrmShiftManager,
  "daily-task-approval": ADMIN_SHELL_ROLES,
  // === ROUTE PERMS F02 === Worker inserts hrm-positions/hrm-training/hrm-daily-work/hrm-incidents keys ABOVE this marker
  // === END ROUTE PERMS F02 ===
  // F03 MENU-GUIDELINE START
  "menu-guideline": ADMIN_SHELL_ROLES,
  // F03 MENU-GUIDELINE END
};

const ADMIN_ROUTE_ORDER = [
  "dashboard",
  "companies",
  "employees",
  "contracts",
  "onboarding",
  "org-chart",
  "master",
  "tasks",
  "attendance",
  "shifts",
  "kpi",
  "payroll",
  "excel",
  "ocr",
  "pos",
  "stock",
  "kitchen",
  "htx",
  "legacy-payroll",
  "audit-history",
  "legal-vault",
  "legal-requests",
  "legal-grants",
  "legal-audit",
  // === ROUTE ORDER F01 === Worker inserts legal-vault/legal-requests/legal-audit ABOVE this marker
  // === END ROUTE ORDER F01 ===
  "hrm-positions",
  "hrm-training",
  "hrm-daily-work",
  "hrm-incidents",
  "daily-task-approval",
  // === ROUTE ORDER F02 === Worker inserts hrm-positions/hrm-training/hrm-daily-work/hrm-incidents ABOVE this marker
  // === END ROUTE ORDER F02 ===
  // F03 MENU-GUIDELINE START
  "menu-guideline",
  // F03 MENU-GUIDELINE END
];

export function canAccessAdminRoute(role, routeKey) {
  return Boolean(role && ADMIN_ROUTE_PERMISSIONS[routeKey]?.includes(role));
}

export function canUseAdminShell(role) {
  return Boolean(role && ADMIN_SHELL_ROLES.includes(role));
}

export function defaultAdminPath(role) {
  if (!canUseAdminShell(role)) return "/staff";
  const routeKey = ADMIN_ROUTE_ORDER.find((key) => canAccessAdminRoute(role, key));
  if (!routeKey) return "/staff";
  return routeKey === "dashboard" ? "/admin" : `/admin/${routeKey}`;
}

export function portalPathForRole(role) {
  return canUseAdminShell(role) ? defaultAdminPath(role) : "/staff";
}
